import { render, staticRenderFns } from "./AiNavigation.vue?vue&type=template&id=83ba2876&scoped=true&"
import script from "./AiNavigation.vue?vue&type=script&lang=js&"
export * from "./AiNavigation.vue?vue&type=script&lang=js&"
import style0 from "./AiNavigation.vue?vue&type=style&index=0&id=83ba2876&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ba2876",
  null
  
)

export default component.exports